// eslint-disable-next-line
/// <reference path="../../../node_modules/@types/resize-observer-browser/index.d.ts" />
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { NoopNgZone } from '@recruitee/common';
import { phraseAppTranslationsLoader, PHRASE_APP_TRANSLATIONS } from '@recruitee/i18n';
import { uiTranslations } from '@recruitee/user-interface/locales';

// eslint-disable-next-line
import { appTranslations } from '../../recruitee/src/app/locales/app-locales';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

phraseAppTranslationsLoader('en', 'en', [appTranslations, uiTranslations]).then(translations => {
  platformBrowserDynamic([
    {
      provide: PHRASE_APP_TRANSLATIONS,
      useValue: translations,
    },
  ])
    .bootstrapModule(AppModule, { ngZone: new NoopNgZone() })
    .catch(err => console.error(err));
});
